import React, { useCallback, useMemo } from 'react';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { useMessages } from 'modules/intl';
import {
  SmartDiaryViewOptions,
  useSmartTimesheetContext
} from './SmartTimesheetContextProvider';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(15)
  },
  hidden: {
    display: 'none'
  },
  show: {
    display: 'block'
  }
}));

const useSelectStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1)
  },
  outlined: {
    padding: theme.spacing(0.25)
  }
}));

const messageIds = [
  'timesheetPeriods.today',
  'smartDiary.currentTimesheetPeriod'
];
export const SmartDiaryViewOptionsSelector: React.FC = React.memo(() => {
  const classes = useStyles();
  const selectStyles = useSelectStyles();
  const {
    selectedViewOption,
    setSelectedViewOption
  } = useSmartTimesheetContext();

  const messages = useMessages(messageIds);

  const viewOptions = useMemo(
    () => [
      {
        value: SmartDiaryViewOptions.Today,
        text: messages['timesheetPeriods.today']
      },
      {
        value: SmartDiaryViewOptions.CurrentPeriod,
        text: messages['smartDiary.currentTimesheetPeriod']
      }
    ],
    [messages]
  );

  const handleChange = useCallback(
    (event) => {
      setSelectedViewOption(event.target.value);
    },
    [setSelectedViewOption]
  );
  const showCustomOption =
    selectedViewOption === SmartDiaryViewOptions.Custom
      ? classes.show
      : classes.hidden;
  return (
    <Box
      component="span"
      className={classes.root}
      data-testid="smart-diary-view-option-selector"
    >
      <FormControl variant="outlined" className={classes.root}>
        <Select
          classes={selectStyles}
          data-testid="smart-diary-view-option-simple-select"
          value={selectedViewOption}
          onChange={handleChange}
        >
          <MenuItem
            value={SmartDiaryViewOptions.Custom}
            className={showCustomOption}
          >
            <FormattedMessage id="timesheetPeriods.custom" />
          </MenuItem>
          {viewOptions.map(({ value, text }) => {
            return (
              <MenuItem
                key={value}
                value={value}
                data-testid={`smart-diary-option_${value}`}
              >
                {text}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
});

SmartDiaryViewOptionsSelector.displayName = 'SmartDiaryViewOptionsSelector';
